import { render, staticRenderFns } from "./snack.vue?vue&type=template&id=64fac3a1&"
import script from "./snack.vue?vue&type=script&lang=ts&"
export * from "./snack.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/scss/components/snack.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports